export default __webpack_public_path__ + "static/media/pn.0dde44ab.svg";